import { Skeleton } from "@/components/ui/skeleton";

const ChatLoading = () => {
  return (
    <div className="flex size-full flex-col items-center">
      <div className="flex size-full max-w-full flex-col space-y-4 px-6">
        {/* User message skeleton */}
        <div className="flex w-full justify-end">
          <div className="flex max-w-[80%] flex-col space-y-2">
            <Skeleton className="h-16 w-64 rounded-3xl" />
          </div>
        </div>

        {/* Assistant message skeleton */}
        <div className="flex w-full">
          <div className="flex max-w-[80%] flex-col space-y-2">
            {" "}
            <Skeleton className="h-24 w-72 rounded-3xl" />
          </div>
        </div>

        {/* User message skeleton */}
        <div className="flex w-full justify-end">
          <div className="flex max-w-[80%] flex-col space-y-2">
            <Skeleton className="h-12 w-48 rounded-3xl" />
          </div>
        </div>

        {/* Assistant message skeleton */}
        <div className="flex w-full">
          <div className="flex max-w-[80%] flex-col space-y-2">
            <Skeleton className="h-32 w-80 rounded-3xl" />
          </div>
        </div>
      </div>

      <div className="sticky bottom-0 mt-3 flex w-full flex-col items-center">
        <div className="flex size-full justify-center bg-background">
          <div className="flex w-full max-w-full flex-col items-center justify-end px-6 pb-4">
            <Skeleton className="h-12 w-full rounded-md" />
            <div className="mt-2 text-xs text-muted-foreground">
              AI can make mistakes. Please review for accuracy.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLoading;
